<div #spacer class="w-[72px] shrink-0"></div>

<aside
    class="group absolute bottom-0 top-0 z-[999] flex w-[72px] flex-col overflow-hidden border-r border-zinc-200/80 bg-twComponentBackground shadow-menu transition-[width] duration-300 ease-out-expo hover:w-[264px]"
    aria-label="Sidebar">
    <!-- BRAND -->
    <a
        class="group/logo flex shrink-0 items-center gap-3 px-[18px] pb-5 pt-7"
        aria-label="Twinny"
        [routerLink]="SLUGS.DASHBOARD">
        <span class="flex w-[22px] shrink-0 justify-center">
            <app-twinny-brand
                class="text-twTextPrimary transition-transform duration-300 ease-out-expo group-hover/logo:scale-110"
                size="sm"
                [showText]="false" />
        </span>
        <span
            class="-translate-x-1 whitespace-nowrap text-[18px] font-semibold leading-none tracking-[-0.04em] text-twTextPrimary opacity-0 transition-[opacity,transform] duration-300 ease-out-expo group-hover:translate-x-0 group-hover:opacity-100">
            Twinny
        </span>
    </a>

    <div class="mx-5 h-px bg-zinc-200/0 transition-colors duration-300 group-hover:bg-zinc-200/70"></div>

    <!-- NAV -->
    <menu class="flex flex-grow flex-col gap-0.5 px-2.5 pb-4 pt-3">
        @for (opt of OPTS; track opt.link; let last = $last) {
            @if (last && showTrialWarning()) {
                <div
                    class="mx-1 mb-3 mt-auto hidden flex-col gap-3 overflow-hidden rounded-2xl border border-amber-200/70 bg-gradient-to-br from-amber-50 to-orange-50/70 p-4 opacity-0 transition-opacity duration-300 group-hover:flex group-hover:opacity-100 dark:border-amber-900/40 dark:from-amber-900/15 dark:to-orange-900/10">
                    <div class="flex items-start gap-2.5">
                        <lucide-icon
                            class="mt-0.5 shrink-0 text-amber-500"
                            [img]="WarningIcon"
                            [size]="18"
                            [strokeWidth]="1.75" />
                        <p class="text-[12px] font-medium leading-snug text-amber-900 dark:text-amber-100">
                            {{ trialText() }}
                        </p>
                    </div>
                    <button
                        class="w-full rounded-xl bg-zinc-900 px-3 py-2 text-[12.5px] font-semibold text-white shadow-ctaPrimary transition-[transform,background-color] duration-200 ease-out-expo hover:-translate-y-px hover:bg-zinc-800"
                        (click)="handleSubscribe()">
                        {{ BILLING_TRANSLATION_KEYS.warning.subscribeAction | translate }}
                    </button>
                </div>
            }

            <a
                class="group/link relative flex h-10 items-center rounded-xl px-3 text-zinc-500 transition-[background-color,color] duration-200 ease-out-expo hover:bg-zinc-50 hover:text-zinc-900"
                [ngClass]="{
                    'mt-auto': last,
                    'group-hover:mt-0': last && showTrialWarning()
                }"
                routerLinkActive="active"
                [routerLink]="opt.link">
                <!-- left accent bar (active only) -->
                <span
                    class="pointer-events-none absolute left-0 top-1/2 h-5 w-[2.5px] -translate-x-2 -translate-y-1/2 rounded-full bg-primary-600 opacity-0 transition-[opacity,transform] duration-300 ease-out-expo group-[.active]/link:translate-x-0 group-[.active]/link:opacity-100"></span>

                <span
                    class="relative flex size-[18px] shrink-0 items-center justify-center text-zinc-400 transition-colors duration-200 ease-out-expo group-hover/link:text-zinc-700 group-[.active]/link:text-primary-600">
                    <lucide-icon [img]="opt.icon" [size]="18" [strokeWidth]="1.75" />
                </span>
                <span
                    class="ml-3 -translate-x-1 whitespace-nowrap text-[13.5px] font-medium tracking-[0.005em] opacity-0 transition-[opacity,transform] duration-300 ease-out-expo group-hover:translate-x-0 group-hover:opacity-100 group-[.active]/link:text-primary-700">
                    {{ opt.title }}
                </span>

                <!-- subtle hover dot for active state -->
                <span
                    class="ml-auto hidden h-1.5 w-1.5 rounded-full bg-primary-500/70 opacity-0 transition-opacity duration-300 group-[.active]/link:block group-hover:opacity-100"></span>
            </a>
        }
    </menu>
</aside>
